import { ThemeProvider } from "@amzn/storm-ui";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { getApplicationBasename } from "./basename";
import reportWebVitals from "./reportWebVitals";

const rootEl = document.getElementById("cdb-root");
if (rootEl) {
    const root = ReactDOM.createRoot(rootEl);
    const basename = getApplicationBasename();

    root.render(
        <ThemeProvider>
            <BrowserRouter basename={basename}>
                <App />
            </BrowserRouter>
        </ThemeProvider>,
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}
